var map = {
	"./bimeh_points_province_10_2025-04-29": [
		8703,
		8703
	],
	"./bimeh_points_province_11_2025-04-29": [
		6526,
		6526
	],
	"./bimeh_points_province_12_2025-04-29": [
		4645,
		4645
	],
	"./bimeh_points_province_13_2025-04-29": [
		8540,
		8540
	],
	"./bimeh_points_province_14_2025-04-29": [
		459,
		459
	],
	"./bimeh_points_province_15_2025-04-29": [
		5930,
		5930
	],
	"./bimeh_points_province_16_2025-04-29": [
		369,
		369
	],
	"./bimeh_points_province_17_2025-04-29": [
		8152,
		8152
	],
	"./bimeh_points_province_18_2025-04-29": [
		4647,
		4647
	],
	"./bimeh_points_province_19_2025-04-29": [
		8438,
		8438
	],
	"./bimeh_points_province_1_2025-04-29": [
		1173,
		1173
	],
	"./bimeh_points_province_20_2025-04-29": [
		7782,
		7782
	],
	"./bimeh_points_province_21_2025-04-29": [
		3991,
		3991
	],
	"./bimeh_points_province_22_2025-04-29": [
		9892,
		7511
	],
	"./bimeh_points_province_23_2025-04-29": [
		7309,
		7309
	],
	"./bimeh_points_province_24_2025-04-29": [
		1586,
		1586
	],
	"./bimeh_points_province_25_2025-04-29": [
		7171,
		7171
	],
	"./bimeh_points_province_26_2025-04-29": [
		7120,
		7120
	],
	"./bimeh_points_province_27_2025-04-29": [
		233,
		233
	],
	"./bimeh_points_province_28_2025-04-29": [
		5870,
		5870
	],
	"./bimeh_points_province_29_2025-04-29": [
		5519,
		5519
	],
	"./bimeh_points_province_2_2025-04-29": [
		2702,
		2702
	],
	"./bimeh_points_province_30_2025-04-29": [
		7181,
		7181
	],
	"./bimeh_points_province_31_2025-04-29": [
		820,
		820
	],
	"./bimeh_points_province_3_2025-04-29": [
		7407,
		7407
	],
	"./bimeh_points_province_4_2025-04-29": [
		1896,
		1896
	],
	"./bimeh_points_province_5_2025-04-29": [
		7569,
		7569
	],
	"./bimeh_points_province_6_2025-04-29": [
		8186,
		8186
	],
	"./bimeh_points_province_7_2025-04-29": [
		8235,
		8235
	],
	"./bimeh_points_province_8_2025-04-29": [
		9588,
		9588
	],
	"./bimeh_points_province_9_2025-04-29": [
		9005,
		9005
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5882;
module.exports = webpackAsyncContext;